import ApiService from '@/core/api/api.service';
import { UserService } from '@/core/user';
import store from '@/store';

import { functionsWithNotifications } from '@/core/notifications';
import fePreferenceMessages from './fe-preference.messages';

const functions = {
  get,
  save,
  update,
  remove,
};

export default {
  ...functionsWithNotifications(functions, fePreferenceMessages),
};

const fePreferenceApi = new ApiService({
  baseUrl: store.getters.umBaseUrl,
});
fePreferenceApi.extendBaseUrl('/me/fe_preferences');

async function get(key) {
  const user = _.get(store.state, 'user') || await UserService.getUser();
  const foundPreference = user.fe_preferences
    .find(preference => Object.keys(preference).includes(key)) || {};
  return _.cloneDeep(foundPreference[key]);
}

async function clearUserCacheAndRefetch() {
  UserService.clearCache();
  await UserService.getUser();
}

async function save(key, value) {
  const requestBody = {
    [key]: value,
  };

  const response = await fePreferenceApi.post('', requestBody);
  await clearUserCacheAndRefetch();
  return _.get(response.data, `fe_preference['${key}']`);
}

async function update(key, value) {
  const response = await fePreferenceApi.patch(key, value);
  await clearUserCacheAndRefetch();
  return _.get(response.data, `fe_preference['${key}']`);
}

async function remove(key) {
  await fePreferenceApi.delete(key);
  await clearUserCacheAndRefetch();
}
